import { ZCDFlex, ZCDSpacer, ZCDSwitch, ZCDTypography } from '@zencity/common-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OverallSatisfactionScoreQuestion } from 'screens/WidgetGenerator/utils/misc';
import { ServicesBarChartWidget } from './ServicesBarChartWidget';
import { determineNoDataExplanation, generateWidgetData } from './helpers';

interface Props {
  widgetData: OverallSatisfactionScoreQuestion[];
  servicesBarChartNumRowsPerTable?: number;
  selectedServiceBarAspects?: string[];
  replaceClientTokenWith?: string;
  tableIndexToDisplay?: number;
}

export const ServicesBarChartWidgetWrapper = (props: Props) => {
  const {
    widgetData,
    servicesBarChartNumRowsPerTable,
    selectedServiceBarAspects = [],
    replaceClientTokenWith,
    tableIndexToDisplay,
  } = props;

  const { t: translate } = useTranslation();

  const displayNoDataExplanation = determineNoDataExplanation(widgetData);

  const filteredData = generateWidgetData({
    widgetData,
    selectedServiceBarAspects,
    replaceClientTokenWith,
    servicesBarChartNumRowsPerTable,
  });

  const singleTableToDisplay =
    tableIndexToDisplay !== undefined && tableIndexToDisplay <= filteredData.length
      ? filteredData[tableIndexToDisplay - 1]
      : [];
  const errorInTableIndex = tableIndexToDisplay && singleTableToDisplay.length === 0;

  return (
    <ZCDFlex flexDirection="column" width="100%" height="100%">
      <ZCDSwitch>
        <ZCDSwitch.Case condition={!!errorInTableIndex}>
          <ZCDTypography>{translate('widgetGenerator.widgets.servicesBarChart.tablePageError')}</ZCDTypography>
        </ZCDSwitch.Case>
        <ZCDSwitch.Case condition={singleTableToDisplay.length > 0}>
          <ServicesBarChartWidget
            widgetData={singleTableToDisplay}
            displayNoDataExplanation={displayNoDataExplanation}
          />
        </ZCDSwitch.Case>
        <ZCDSwitch.Default>
          {filteredData.map((chunk) => (
            <React.Fragment key={`${chunk[0].text}_element_key`}>
              <ServicesBarChartWidget widgetData={chunk} displayNoDataExplanation={displayNoDataExplanation} />
              <ZCDSpacer orientation="vertical" size="small" />
            </React.Fragment>
          ))}
        </ZCDSwitch.Default>
      </ZCDSwitch>
    </ZCDFlex>
  );
};
